import { ILocation } from '@/models/location';
import APIService from '../api';

type SuggestionPayload = {
  businessId: string;
} & Pick<ILocation, 'address' | 'city' | 'country' | 'state'>;

class LocationsService extends APIService {
  get resource() {
    return `/admin/business-location`;
  }

  getLocations(
    sortField?: string,
    sortOrder?: string,
    pagination?: string,
    filters?: string
  ) {
    const resource = this.generateResource(
      `${this.resource}?`,
      sortField || '',
      sortOrder,
      pagination,
      filters
    );

    return this.get(resource);
  }

  create(data: object) {
    return this.post(this.resource, data);
  }

  edit(locationId: string, data: object) {
    return this.put(`${this.resource}/${locationId}`, data);
  }

  remove(locationId: string) {
    return this.delete(`${this.resource}/${locationId}`);
  }

  associateOfferToLocation(data: object) {
    return this.post(`/admin/offer/location`, data);
  }

  getSuggestionName(payload: SuggestionPayload) {
    return this.get(`/v2/location/suggestion-name/${payload.businessId}`, {
      params: {
        address: payload.address,
        city: payload.city,
        state: payload.state,
        country: payload.country
      }
    });
  }
}

export default LocationsService;
